import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { Case, ClinicalDataRecord, getCaseApiUrl } from '@/api/apis/case';
import {
  KidneyRandomizationClinicalData,
  RandomizationClinicalData,
} from '@/api/apis/cases/clinical-data/clinical-data.types';

const randomizationClinicalData = async (caseId: string, data: RandomizationClinicalData) => {
  const res = await http.post<ApiResponseBody<Case>>(getCaseApiUrl.randomizationClinicalData(caseId), data);

  return res.data.data;
};

/** Creates or replaces the single kidney randomization record. */
const setKidneyRandomization = async (caseId: string, data: KidneyRandomizationClinicalData) => {
  const res = await http.post<ApiResponseBody<ClinicalDataRecord>>(getCaseApiUrl.kidneyRandomization(caseId), data);

  return res.data.data;
};

const deleteKidneyRandomization = async (caseId: string) => {
  const res = await http.delete<ApiResponseBody<Case>>(getCaseApiUrl.kidneyRandomization(caseId));

  return res.data.data;
};

export const clinicalDataFetcher = {
  randomizationClinicalData,
  setKidneyRandomization,
  deleteKidneyRandomization,
};
